import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const PracticeExamRecordService = {
  state: {},

  mutations: {},

  actions: {
    /**
     * 练习记录分页
     */
    practiceExamRecordPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'practiceExamRecord/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得练习记录
    */
    practiceExamRecordGetById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'practiceExamRecord/getById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 根据主键获得练习记录详情
    */
    practiceExamRecordGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.EXAM + 'practiceExamRecord/getDetailsById/' + id).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    /**
     * 练习记录保存
     */
    practiceExamRecordSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'practiceExamRecord/save', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 练习记录删除
     */
    practiceExamRecordRemove({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.EXAM + 'practiceExamRecord/remove', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default PracticeExamRecordService
